// @flow
import { MEMBER_HEADER_HEIGHT } from '../../Feed/Styles/MemberHeader.Style';

const COL_COLOR_WIDTH = 60;
const COL_NAME_WIDTH = 200;
const COL_CUSTCNT_WIDTH = 200;
const COL_ACTION_WIDTH = 220;
const ACTION_WIDTH = 40;

const tagsContentStyles = {
  tableContainer: (theme) => ({
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(3), // Desktop padding
    // maxWidth: 700,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      padding: 0
      // paddingTop is now handled by ContentContainer wrapper
    }
  }),

  customFeedTableHeadRow: (theme) => ({
    '& th': {
      cursor: 'pointer'
    }
  }),

  colAction: (theme) => ({
    width: COL_ACTION_WIDTH
  }),

  colorCell: (theme) => ({
    flex: '0 0 auto',
    flexBasis: COL_COLOR_WIDTH,
    maxWidth: COL_COLOR_WIDTH,
    cursor: 'pointer',
    height: 52,
    borderTopLeftRadius: 24,
    borderBottomLeftRadius: 24,
    borderBottom: 0,
    backgroundColor: 'white',
    '& span svg': {
      fontSize: '1.6rem'
    }
  }),

  nameCell: (theme) => ({
    flex: '1 1 auto !important',
    minWidth: COL_NAME_WIDTH,
    maxWidth: '100% !important',
    paddingRight: theme.spacing(1),
    paddingLeft: `${theme.spacing(4)}px !important`,
    width: 'auto',
    overflowX: 'scroll'
  }),

  custCountCell: (theme) => ({
    flex: '0 0 auto',
    maxWidth: COL_CUSTCNT_WIDTH,
    minWidth: COL_CUSTCNT_WIDTH
  }),

  customTableStyles: (theme) => ({
    '& td': {
      cursor: 'default'
    },
    '& .underActionCell': {
      flex: '0 0 auto',
      minWidth: COL_ACTION_WIDTH,
      maxWidth: COL_ACTION_WIDTH,
      paddingRight: 0,
      paddingLeft: theme.spacing(1),
      width: 'auto'
    },
    '& .hover .underActionCell': {
      flex: '1 1 auto',
      // minWidth: COL_ACTION_WIDTH / 2,
      // maxWidth: COL_ACTION_WIDTH / 2,
      // minWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2) - theme.spacing(1),
      // maxWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2) - theme.spacing(1),

      // minWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2) - parseInt(theme.spacing(1), 10),
      // maxWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2) - parseInt(theme.spacing(1), 10),
      minWidth: 140,
      maxWidth: 140,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
      // width: 'auto'
    }
  }),

  arrowIcon: (theme) => ({
    fontSize: '1.2rem',
    position: 'relative',
    top: 1,
    marginLeft: theme.spacing(0.375),
    color: '#66666a',
    verticalAlign: 'text-bottom'
  })
};

export default tagsContentStyles;